.base {
  padding: 0;
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--accent-secondary);
  background: none;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.base:hover {
  text-decoration: underline;
}

.base:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}
